import React, { useState, useEffect } from "react";
import PersonalDetailsStyles from "./PersonalDetails.styles";
import {
  Autocomplete,
  Box,
  Checkbox,
  Divider,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  InputAdornment,
  InputLabel,
  Radio,
  RadioGroup,
  TextField,
  TextareaAutosize,
  Typography,
} from "@mui/material";
import profileImg from "../../../../../assets/images/user-default.svg";
import CustomInput from "../../../../../global/components/CustomInput/CustomInput";
import CustomButton from "../../../../../global/components/CustomButton/CustomButton";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import {
  isTruthy,
  openErrorNotification,
  openSuccessNotification,
} from "../../../../../helpers/methods";
import notifiers from "../../../../../global/constants/NotificationConstants";
import customErrorHandler from "../../../../../utils/customErrorHandler";
import CustomLoader from "../../../../../global/components/CustomLoader/CustomLoader";
import {
  getFinalBodyStructure,
  handleValidation,
  // handleValidation,
  // handleValidation,
  initialState,
  validateInput,
} from "./Validation";
import { getAllUsers, getCountry, getState } from "./PersonalDetailsService";
import {
  RegisterEmployee,
  getPerosnalDetails,
  updatePersonalDetail,
  getRoleById,
  getLeaveDetail,
} from "../StepperService";
import { ImageUpLoad } from "../EmployeeDocuments/EmployeeDocumentServices";
import { useForm } from "react-hook-form";
import { Label } from "@mui/icons-material";
import {
  assignLeadsToUser,
  changeAt,
  changeStage,
  getAllSource,
  getAllStage,
  getAllTeam,
  getAllTeamData,
  getAllTeamMembersData,
} from "../../ShowAll/ShowAllService";
import {
  getAllTeamDataProject,
  getAllTeamMembersDataProject,
} from "../../../../Project/components/stepper/Personal Details/PersonalDetailsService";
import { isJSDocOptionalType } from "typescript";
import { store } from "../../../../../utils/store";
import customTableStyles from "../../../../../global/components/CustomTable/customTable.styles";
const _ = require("lodash");

let clonedObject = {};

interface CustomProps {
  nextStep?: () => void | undefined;
  userId: String;
  setUserId?: Function;
  fromSettingOrLogout?: any;
  addNewTeamDialog: any;
  eventForEdit: any;
  handleCloseAddTeam: Function;
}
const PersonalDetails = (props: CustomProps) => {
  const classes = PersonalDetailsStyles;
  const [developerList, setDeveloperName] = useState<any>([]);
  const [projectList, setProjectName] = useState<any>([]);
  const [apiResponse, setApiResponse] = useState(false);
  const [country, setCountry] = useState<any>([]);
  const [state, setState] = useState([]);
  const [leadOptionMembers, setLeadOptionMembersas] = useState<any>([]);
  const [leadOption, setLeadOption] = useState<any>([]);
  const [selectedOptions, setSelectedOptions] = useState<any>([]);
  const [selectedOptionsMembers, setSelectedOptionsMembers] = useState<any>([]);
  const [idForTeam, setIdForTeam] = useState<any>([]);
  const [idForMember, setIdForMember] = useState<any>([]);
  console.log(props, ":::::PROPSSS")
  useEffect(() => {
    tableDataShowHandler();
  }, []);
  const id = store.getState().auth.userId || {};

  const tableDataShowHandler = async () => {
    try {
      const response1 = await getAllTeamData("");
      const assignToData = response1.data.flatMap((team: any) => {
        const subTeams = team.sub_teams?.map((subTeam: any) =>

        ({

          id: subTeam._id,
          label: subTeam.team_name,
          selected: subTeam?.is_available,
          isParent: false,
          teamMembers: subTeam.team_members.length
            ? subTeam.team_members.map((member: any) => {
              return {
                id: member.userId,
                label: member.users[0].name,
                selected: 0,
              };
            })
            : null,

        })) || [];

        const mainTeam = {
          id: team._id,
          label: team.team_name,
          selected: team?.is_available,
          isParent: true,
          teamMembers: team.team_members.length

            ? team.team_members.map((member: any) => {
              return {
                id: member.userId,
                label: member.users[0].name,
                selected: 0,
              };
            })
            : null,
        };
        return [mainTeam, ...subTeams];
      })
      setLeadOption(
        assignToData
      );

      const selectedData = assignToData
        .filter((e: any) => {
          return e?.selected == 1;
        })
        .map((e: any) => {
          console.log(e, "Processing in map");
          return {
            id: e.id,
            label: e.label,
            selected: e?.selected,
            teamMembers: Array.isArray(e.teamMembers)
              ? e.teamMembers.map((member: any) => ({
                id: member.id,
                label: member.label,
                selected: 0,
              }))
              : null,
          };
        });

      setSelectedOptions(
        selectedData
      );
      // const response1 = await getAllTeamData("");
      // setLeadOption(
      //   response1.data.map((e: any) => {
      //     return {
      //       id: e._id,
      //       label: e.team_name,
      //       selected: e?.is_available,
      //       teamMembers: e.team_members.length
      //         ? e.team_members.map((member: any) => {
      //           return {
      //             id: member.userId,
      //             label: member.users[0].name,
      //             selected: 0,
      //           };
      //         })
      //         : null,
      //     };
      //   })
      // );
      // setSelectedOptions(
      //   response1.data
      //     .filter((e: any) => e?.is_available === 1)
      //     .map((e: any) => {
      //       return {
      //         id: e._id,
      //         label: e.team_name,
      //         selected: e?.is_available,
      //         teamMembers: e.team_members.length
      //           ? e.team_members.map((member: any) => {
      //             return {
      //               id: member.userId,
      //               label: member.users[0].name,
      //               selected: 0,
      //             };
      //           })
      //           : null,
      //       };
      //     })
      // );

      // const ids = response1.data
      //   .filter((e: any) => e?.is_available === 1)
      //   .map((e: any) => e._id);

      // if (ids) {
      //   handelDropdownAfterSelect(ids);
      // }
      const ids = assignToData
        .filter((e: any) => e?.selected === 1)
        .map((e: any) => e.id);
      if (ids) {
        handelDropdownAfterSelect(ids, id);
      }

    } catch (error: any) {
      setApiResponse(false);
      openErrorNotification(
        isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
      );
    }
  };

  const submitForm = async () => {
    if (selectedOptionsMembers.length) {
      try {
        const idLead = props.addNewTeamDialog?.data?.map((item: any) => {
          return `'${item}'`;
        });
        const idMembers = selectedOptionsMembers.map((item: any) => {
          return `'${item.id}'`;
        });
        const teamIds = selectedOptions.map((item: any) => {
          return `'${item.id}'`;
        });
        const payload = {
          lead_id: idLead.join(","),
          team_id: teamIds.join(","),
          user_id: idMembers.join(",")
        }
        console.log(payload, "djbveijvbefvbekvbrvkrbvkrbkbjdfkjdbfjksdfbdk.jbfkj")
        const res = await assignLeadsToUser(payload);
        props.handleCloseAddTeam()
        if (res?.success) {
          openSuccessNotification(res?.message);
          props.nextStep?.();
        } else {
          customErrorHandler(res);
        }
      }
      catch {

      }
    } else {
      openErrorNotification(
        "Please select Members to assign"
      );
    }
  };



  const handleOptionCheckboxChange = (option: any, event: any) => {
    const isChecked = event.target.checked ?? !option.selected; // Handle li & checkbox clicks
  
    if (isChecked) {
      const updatedOption = { ...option, selected: 1 };
      setSelectedOptions([...selectedOptions, updatedOption]);
      setLeadOption((prev: any) =>
        prev.map((item: any) => (item.id === option.id ? updatedOption : item))
      );
  
      if (option.teamMembers) {
        setLeadOptionMembersas((prev: any) => [
          ...prev,
          ...option.teamMembers.map((member: any) => ({
            pId: option.id,
            id: member.id,
            label: member.label,
            selected: 0,
          })),
        ]);
      }
    } else {
      setSelectedOptions(selectedOptions.filter((item: any) => item.id !== option.id));
      setLeadOptionMembersas(leadOptionMembers.filter((item: any) => item.pId !== option.id));
  
      setLeadOption((prev: any) =>
        prev.map((item: any) => (item.id === option.id ? { ...item, selected: 0 } : item))
      );
    }
  };
  // const handelDropdownAfterSelect = async (ids: any) => {
  //   try {
  //     const payload = {
  //       team_id: ids,
  //     };
  //     const response1 = await getAllTeamMembersDataProject(payload);
  //     console.log(response1, "chiragtyagi");

  //     setLeadOptionMembersas(
  //       response1.data.flatMap((member: any) => {
  //         return member?.team_members?.map((mem: any) => {
  //           console.log(mem, member, "memberrrr");

  //           return {
  //             pId: member._id,
  //             id: mem.users[0]._id,
  //             label: mem.users[0]?.name,
  //             selected: 1,
  //           };
  //         });
  //       })
  //     );

  //     setSelectedOptionsMembers(
  //       response1.data
  //         .flatMap((member: any) => {
  //           return member?.team_members?.map((mem: any) => {
  //             console.log(mem, member, "memberrrr");

  //             return {
  //               pId: member._id,
  //               id: mem.users[0]._id,
  //               label: mem.users[0]?.name,
  //               // selected: mem?.is_available,
  //               selected: 1,
  //             };
  //           });
  //         })
  //         .filter((item: any) => item.selected === 1)
  //     );
  //   } catch { }
  // };


  const handelDropdownAfterSelect = async (ids: any, id: any = null) => {
    try {
      const payload = {
        team_id: ids,
        lead_id: id?.id,
      };
      const response1 = await getAllTeamMembersData(payload);
      setLeadOptionMembersas(
        response1.data.flatMap((member: any) => {
          return member?.team_members?.map((mem: any) => {
            return {
              pId: member._id,
              id: mem.users[0]._id,
              label: mem.users[0]?.name,
              selected: mem?.is_available,
            };
          });
        })
      );
      const members = response1.data
        .flatMap((member: any) => {
          return member?.team_members?.map((mem: any) => {
            return {
              pId: member._id,
              id: mem.users[0]?._id,
              label: mem.users[0]?.name,
              selected: mem?.is_available,
            };
          });
        })
        .filter((item: any) => item.selected === 1);

      setSelectedOptionsMembers(
        response1.data
          .flatMap((member: any) => {
            return member?.team_members?.map((mem: any) => {
              return {
                pId: member._id,
                id: mem.users[0]._id,
                label: mem.users[0]?.name,
                selected: mem?.is_available,
              };
            });
          })
          .filter((item: any) => item.selected === 1)
      );
    } catch { }
  };
  // const handleOptionCheckboxChange1 =
  //   (option: any, value: any) => (event: any, index: any) => {
  //     if (event.target.checked) {
  //       setIdForMember((prev: any) => [...prev, option.id]);
  //       const opt = { ...option, ["selected"]: 1 };
  //       const objIndex = leadOptionMembers.findIndex(
  //         (item: any) => item.id === option.id
  //       );
  //       leadOptionMembers[objIndex] = opt;
  //       setLeadOptionMembersas((prev: any) => [...leadOptionMembers]);

  //       console.log("chirag", option, selectedOptions, leadOption, objIndex);
  //       setSelectedOptionsMembers([...selectedOptionsMembers, opt]);
  //     } else {
  //       setSelectedOptionsMembers(
  //         selectedOptionsMembers.filter((item: any) => item.id !== option.id)
  //       );
  //       // setSelectedOptionsMembers
  //       const opt = { ...option, ["selected"]: 0 };
  //       const objIndex = leadOptionMembers.findIndex(
  //         (item: any) => item.id === option.id
  //       );
  //       leadOptionMembers[objIndex] = opt;
  //       setLeadOptionMembersas((prev: any) => [...leadOptionMembers]);
  //       setIdForMember(idForMember.filter((item: any) => item !== option?.id));
  //       console.log(selectedOptionsMembers, option, "memberselectttt");
  //     }
  //   };
  const handleAssignToMember = (option: any, isChecked: boolean) => {
    const updatedOption = { ...option, selected: isChecked ? 1 : 0 };

    // Update the leadOptionMembers state immutably
    const updatedLeadOptions = leadOptionMembers.map((item: any) =>
      item.id === option.id ? updatedOption : item
    );

    setLeadOptionMembersas(updatedLeadOptions);

    // Update selected options
    const updatedSelectedOptions = isChecked
      ? [...selectedOptionsMembers, updatedOption]
      : selectedOptionsMembers.filter((item: any) => item.id !== option.id);

    setSelectedOptionsMembers(updatedSelectedOptions);

    // Update the idForMember array
    const updatedIdForMember = isChecked
      ? [...idForMember, option.id]
      : idForMember.filter((id: any) => id !== option.id);

    setIdForMember(updatedIdForMember);
  };
  console.log(selectedOptions, selectedOptionsMembers, "::::::KUCH TO DHIK JAAAAAA")

  return (
    <>
      <Grid item xs={14}>
        <Typography sx={classes.HeadingForm}>Assign Lead</Typography>
      </Grid>
      <Grid item>
        <Box>
          <Typography sx={classes.Heading}>Select Team</Typography>
        </Box>
        <div style={{ width: "50%" }}>
          <Grid item xs={12} lg={12}>
            <Box>
              <Typography sx={classes.text1}>Assigned To</Typography>
            </Box>

            <Box>
            <Autocomplete
  multiple
  disableClearable
  disableCloseOnSelect
  value={selectedOptions}
  id="controllable-states-demo"
  options={leadOption}
  sx={customTableStyles.autocompleteStyle}
  getOptionLabel={(option: any) => option?.label}
  renderInput={(params) => (
    <TextField {...params} placeholder="Select options" sx={classes.autoInputFill} />
  )}
  renderOption={(props, option: any) => {
    const isChecked = option?.selected === 1;

    return (
      <li
        {...props}
        style={{
          fontSize: "12px",
          fontWeight: option.isParent ? "bold" : "normal",
          marginLeft: option.isParent ? "0px" : "15px",
          display: "flex",
          alignItems: "center",
          cursor: "pointer",
        }}
        onClick={(event) => handleOptionCheckboxChange(option, event)} // Click anywhere in <li>
      >
        <Checkbox
          size="small"
          style={{ fontSize: "10px", height: "5px", width: "5px", marginRight: "10px" }}
          checked={isChecked}
          onChange={(event) => handleOptionCheckboxChange(option, event)} // Also handle checkbox clicks
          onClick={(event) => event.stopPropagation()} // Prevent double event firing
        />
        {option?.label}
      </li>
    );
  }}
/>
            </Box>
          </Grid>
          <Grid item xs={12} lg={12} mt={2}>
            {leadOptionMembers?.length ? (
              <>
                <Box>
                  <Typography sx={classes.text1}>Assigned To Member</Typography>
                </Box>

                <Box>
                  <Autocomplete
                    multiple
                    disableClearable
                    disableCloseOnSelect
                    value={selectedOptionsMembers}
                    // onChange={(event, newValue) => handleAssignToMember(newValue, "")}
                    id="controllable-states-demo"
                    options={leadOptionMembers}
                    sx={customTableStyles.autocompleteStyle}
                    getOptionLabel={(option: any) => option?.label}
                    renderInput={(params) => (
                      <TextField {...params} placeholder="Select options" sx={classes.autoInputFill} />
                    )}
                    renderOption={(props, option: any, { selected }) => (
                      <li
                        {...props}
                        style={{ fontSize: "10px", display: "flex", alignItems: "center" }}
                        onClick={() => handleAssignToMember(option, option?.selected !== 1)} // Toggle on click
                      >
                        <Checkbox
                          size="small"
                          style={{ fontSize: "10px", height: "5px", width: "5px", marginRight: "10px" }}
                          checked={option?.selected === 1} // Use `selected` prop instead of option?.selected
                          onChange={(event) =>
                            handleAssignToMember(option, event.target.checked)
                          }
                        />
                        {option?.label}
                      </li>
                    )}
                  />

                  {/* <Autocomplete
                    multiple
                    disableClearable
                    disableCloseOnSelect
                    value={selectedOptionsMembers}
                    // onChange={handleAutocompleteChangeCustom1}
                    onChange={(event, newValue) =>
                      handleOptionCheckboxChange1(newValue, "")
                    }
                    id="controllable-states-demo"
                    options={leadOptionMembers}
                    sx={customTableStyles.autocompleteStyle}
                    getOptionLabel={(option: any) => option?.label}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Select options"
                        sx={classes.autoInputFill}
                      />
                    )}
                    renderOption={(props, option: any, { selected }) => (
                      <>
                       
                        <li style={{ fontSize: "10px" }} {...props}>
                          <Checkbox
                            size="small"
                            style={{
                              fontSize: "10px",
                              height: "5px",
                              width: "5px",
                              marginRight: "10px",
                            }}
                            checked={option?.selected}
                            onChange={handleOptionCheckboxChange1(option, "")}
                          />
                          {option?.label}
                        </li>
                      </>
                    )}
                  /> */}
                </Box>
              </>
            ) : (
              ""
            )}
          </Grid>

        </div>
      </Grid>
      <Grid item xs={12} lg={12} mt={3}>
        <CustomButton
          label={"Assign"}
          onClick={submitForm}
          buttonType="primaryBtn"
          customClasses={classes.custombuttonStyle}
        />
      </Grid>
    </>
  );
};

export default PersonalDetails;
